export default __webpack_public_path__ + "static/media/email-icon.5a3487a7.svg";